const settingsTestIDs = {
  settingsScreen: 'settings-screen',
  settingsTitle: 'settings-title',
  settingsSectionTitle: 'settings-section-title',
  // Settings sections
  settingsGeneralSection: 'settings-general-section',
  settingsOtherSection: 'settings-other-section',
  // Settings items
  settingsAccountSettings: 'settings-account-settings',
  settingsSecurity: 'settings-security',
  settingsPrivacyPolicy: 'settings-privacy-policy',
  settingsTermsOfService: 'settings-terms-of-service',
  settingsAppVersion: 'settings-app-version',
  // Settings item
  settingsItemSubTitle: 'settings-item-subtitle',
  settingsItemTitle: 'settings-item-title',
  settingsItemSuffix: 'settings-item-suffix',

  // Account Settings
  accountSettingsScreen: 'account-settings-screen',
  accountSettingsTitle: 'account-settings-title',
  accountSettingsDescription: 'account-settings-description',
  // Account Settings items
  accountSettingsUsername: 'account-settings-username',
  accountSettingsPhone: 'account-settings-phone',
  // Account Settings item
  accountSettingsItemTitle: 'account-settings-item-title',
  accountSettingsItemValue: 'account-settings-item-value',
  accountSettingsItemDescription: 'account-settings-item-description',

  // Security & tracking
  securityScreen: 'security-screen',
  securityTitle: 'security-title',
  securityDescription: 'security-description',
  switchSection: 'switch-section',
  switchTitle: 'switch-title',
  switchElement: 'switch-element',
  trackingPreferencesLabel: 'tracking-pref-label',

  // Notification Settings
  settingsNotificationSettingsScreen: 'notification-settings-screen',

  // Privacy Policy
  privacyPolicyScreen: 'privacy-policy-screen',

  // Terms and Conditions
  termsAndConditionsScreen: 'terms-and-conditions-screen',
};

export default settingsTestIDs;
